import { useEffect, useState } from "react";
import { DenkerBubble } from "@/desktop/onboarding/denker-bubble";
import { DenkerCursorRenderer } from "@/desktop/onboarding/denker-cursor-renderer";
import type { Position } from "@/desktop/onboarding/denker-cursor-controller-types";
import { MEDIA_INTRO_COPY } from "./dolcetto-media-data";

function mediaIntroPosition(): Position {
  if (typeof window === "undefined") return { x: 120, y: 120 };
  return {
    x: Math.max(52, window.innerWidth / 2 - 230),
    y: Math.max(72, window.innerHeight / 2 - 126),
  };
}

function useMediaIntroPosition(): Position {
  const [position, setPosition] = useState<Position>(() =>
    mediaIntroPosition(),
  );

  useEffect(() => {
    const update = () => setPosition(mediaIntroPosition());
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return position;
}

export function MediaDenkerIntro({ visible }: { visible: boolean }) {
  const position = useMediaIntroPosition();

  return (
    <div
      className="dolcetto-media-onboarding-intro"
      data-active={visible ? "true" : "false"}
      data-testid="media-denker-onboarding-intro"
      aria-hidden={!visible}
    >
      <DenkerCursorRenderer position={position} visible={visible} />
      <DenkerBubble
        text={visible ? MEDIA_INTRO_COPY : null}
        position={position}
        syncWithSpeech
      />
    </div>
  );
}
